exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ais-InstantSearch__root .search-pagination{margin-top:20px;text-align:center;margin-bottom:10px}.ais-InstantSearch__root .ais-Hits-item{cursor:pointer;width:100%}.ais-InstantSearch__root .ais-Hits-item:hover{background:#ecf6fd}.ais-InstantSearch__root .result .secondary{font-size:11px;color:#999}.ais-CurrentRefinements{margin-bottom:10px}.ais-CurrentRefinements .ais-CurrentRefinements-delete{margin-left:6px}\n", ""]);

// exports
